/**
 * Expat Questionnaire Repository
 * Repository functions for expat questionnaire API calls
 */

import { ENDPOINTS, path } from '../../shared/endpoints';
import { post } from '../../shared/apiClient';
import {
  CompleteQuestionnaireRequest,
  CompleteQuestionnaireResponse,
  SaveQuestionnaireRequest,
  SaveQuestionnaireResponse,
  StartQuestionnaireRequest,
  StartQuestionnaireResponse,
  AnswerQuestionRequest,
  AnswerQuestionResponse,
} from './types';

// Export types for use in hooks
export type {
  CompleteQuestionnaireRequest,
  CompleteQuestionnaireResponse,
  SaveQuestionnaireRequest,
  SaveQuestionnaireResponse,
  StartQuestionnaireRequest,
  StartQuestionnaireResponse,
  AnswerQuestionRequest,
  AnswerQuestionResponse,
};

/**
 * Submit complete questionnaire
 */
export async function completeQuestionnaire(
  request: CompleteQuestionnaireRequest
): Promise<CompleteQuestionnaireResponse> {
  const response = await post<CompleteQuestionnaireRequest, CompleteQuestionnaireResponse>(
    ENDPOINTS.expat.completeQuestionnaire,
    request
  );
  return response.data;
}

/**
 * Save questionnaire progress
 */
export async function saveQuestionnaire(
  request: SaveQuestionnaireRequest
): Promise<SaveQuestionnaireResponse> {
  const response = await post<SaveQuestionnaireRequest, SaveQuestionnaireResponse>(
    ENDPOINTS.expat.saveQuestionnaire,
    request
  );
  return response.data;
}

/**
 * Start questionnaire session
 */
export async function startQuestionnaire(
  request?: StartQuestionnaireRequest
): Promise<StartQuestionnaireResponse> {
  const response = await post<StartQuestionnaireRequest | undefined, StartQuestionnaireResponse>(
    ENDPOINTS.expat.startQuestionnaire,
    request
  );
  return response.data;
}

/**
 * Submit answer to a question
 */
export async function answerQuestion(
  sessionId: string,
  request: AnswerQuestionRequest
): Promise<AnswerQuestionResponse> {
  const endpoint = path(ENDPOINTS.expat.answerQuestion, { sessionId });
  const response = await post<AnswerQuestionRequest, AnswerQuestionResponse>(
    endpoint,
    request
  );
  return response.data;
}


